"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.css = void 0;

var _util = require("../../../util");

const getIconSize = (theme, size) => {
  switch (size) {
    case 'xsmall':
      return theme.icons.sizeXSmall;

    case 'small':
      return theme.icons.sizeSmall;

    case 'large':
      return theme.icons.sizeLarge;

    case 'xlarge':
      return theme.icons.sizeXLarge;

    case 'xxlarge':
      return theme.icons.sizeXXLarge;

    case 'inline':
    default:
      return '1em';
  }
};

const css = ({
  cssProps,
  theme
}) => {
  const {
    color = 'icon1',
    size = 'inline',
    height,
    width
  } = cssProps || {};
  return {
    color: (0, _util.color)(theme, color) || 'currentColor',
    height: height || getIconSize(theme, size),
    width: width || getIconSize(theme, size)
  };
};

exports.css = css;
//# sourceMappingURL=Icon.style.js.map